import { ResponseDto } from '@r1-frontend/api-domru/api-content/v1/geography/get-city-info';
import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { COOKIE_DOMAIN } from '~/src/constants';

export const prepareCity = (city: ResponseDto): ICurrentCity | Omit<ICurrentCity, 'abnTests'> => ({
    domain: city.domain,
    hostname: `${city.domain}${COOKIE_DOMAIN}`,
    name: city.name,
    cityId: city.city_id,
    phone: city.phone_code === '0' ? city.sale_phone : `+7 (${city.phone_code}) ${city.sale_phone}`,
    callCenter: city.call_center_phone?.length > 10 ? city.call_center_phone : `+7 (${city.phone_code}) ${city.call_center_phone}`,
    billingHost: city.billing_host,
    cityIn: city.pred_name,
    cityTo: city.dat_name,
    internet: !!+city.has_internet,
    ctv: !!+city.has_ctv,
    ktv: !!+city.has_ktv,
    telephony: !!+city.has_telephony,
    videocontrol: !!+city.has_videocontrol,
    phoneCode: city.phone_code === '0' ? 0 : city.phone_code,
    supportPhone: city.phone_code === '0' ? city.support_phone : `+7 (${city.phone_code}) ${city.support_phone}`,
    props: city.props || {},
    companyName: city.company_name,
    legalEntity: city.legal_entity,
    logo: city.logo,
    logoFull: city.logoFull,
    logo_narrow: city.logo_narrow,
    image_map: city.image_map,
    image_map_webp: city.image_map_webp,
    region: city.region || null,
    hasFreeDeliveryAndInstallation: !!+city.has_free_delivery_and_installation,
    has_QPS: city.has_QPS,
    plAvailable: city.pl_available,
    loyaltyProgramCashback: city.loyalty_program_cashback,
    timeZone: city.time_zone,
    withPromoLines: Array.isArray(city.promolines) && city.promolines.length > 0,
});
